import { EntArea } from "./handBooks/area";
import { EntTypeAnimal } from "./handBooks/typeAnimal";

export class EntPopulation {
  id: number = 0;
  animalTypeIds: EntTypeAnimal[] | null = null;
  animalTypes: EntTypeAnimal[] | null = null;
  areaId: EntArea | null = null;
  area: EntArea | null = null;
  areaName: string="";
  count: number | null = null;
}